import { getProjectBySlug } from '../../../../data/projects';
import { CaseStudyPage } from '../../../../components/caseStudy';

const project = getProjectBySlug('rain-alley');

const RainAlleyPage = () => <CaseStudyPage project={project} />;

export default RainAlleyPage;
